// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TGetFormModel, IMappers, TGetFormResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IGetFormResponse } from '../../entities/realtor_form/GetFormResponse';
import type { IErrorResponseSchema } from '../../../../../shared/repositories/lead-realtor-form/entities/schemas/ErrorResponseSchema';

export function createGetFormModel(): TGetFormModel {
  return {
    v: 1,
    apiType: 'private',
    method: 'GET',
    microserviceName: 'lead-realtor-form',
    pathApi: '/v4/get-form/',
    response: {
      '200': {
        contentType: 'json',
      },
      '400': {
        contentType: 'json',
      },
    },
  };
}

export interface IGetFormOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchGetForm<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IGetFormOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TGetFormResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createGetFormModel(),
    config,
  )) as FetchResponse<TGetFormResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetFormResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TGetFormResponse>;
}
